module.exports = __webpack_public_path__ + "img/vegetable-nettles-190x100.6c39bbb1.jpg";